import { render } from "./MarketTemplates.vue?vue&type=template&id=15515d7b&scoped=true"
import script from "./MarketTemplates.vue?vue&type=script&lang=js"
export * from "./MarketTemplates.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/UltimaMonitor_lgames/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15515d7b"]])

export default __exports__